module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1052-e248794d82b76d9164892fd427aa144f.png";